
import * as React from 'react';
import SVG from 'react-inlinesvg';
import { Button } from '__common/components/Button';
import { connect } from 'react-redux';
import { getBaysContainer } from '../../panels/utils/panelsContainer';
import { deleteAllPanels } from '../../panels/utils/panelsManagment';

class ClearArrayButton extends React.Component<onlyDispatchComponentState, {}> {
  clearAll = () => {
    deleteAllPanels();
    getBaysContainer().removeChildren()
  }

  render() {
    return (
      <Button variant="text" onClick={this.clearAll} className="roofs-selector-button" tooltipLabel="Clear array">
        <SVG src={require('assets/media/icons/icon_delete.svg')} />
      </Button>
    );
  }
}

function mapStateToProps(state: appState) {
  return {
    error: state.router?.error || null,
  };
}

export default connect(mapStateToProps)(ClearArrayButton);
